import { useState } from "react";
import { Plus } from "lucide-react";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import LeaderModal from "@/components/LeaderModal";
import { LEADERS } from "@/lib/data";

function truncate(text, max = 180) {
  if (!text) return "";
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  return cut.slice(0, cut.lastIndexOf(" ")) + "…";
}

export default function Leadership() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="leadership-page">
      <PageHero
        eyebrow="Leadership"
        title="The team behind ZT Health"
        subtitle="A multidisciplinary leadership team blending decades of healthcare operations, clinical, financial, and investment experience."
      />

      <section className="zt-section">
        <div className="zt-container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-10 gap-y-16">
            {LEADERS.map((l, i) => (
              <article
                key={l.name}
                data-testid={`leader-card-${i}`}
                className="text-center group cursor-pointer"
                onClick={() => setActive(l)}
              >
                <div className="relative mx-auto w-44 h-44 mb-6">
                  {/* Decorative accent ring (uniform navy) */}
                  <div
                    className="absolute inset-0 rounded-full transition-transform duration-500 group-hover:scale-105"
                    style={{ background: "var(--zt-navy)" }}
                  />
                  <div className="absolute inset-1.5 rounded-full overflow-hidden bg-slate-100">
                    <img
                      src={l.image}
                      alt={l.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                  </div>
                  {/* Read more badge that appears on hover */}
                  <div
                    className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ background: "var(--zt-navy)" }}
                  >
                    <Plus size={20} />
                  </div>
                </div>
                <h3 className="text-lg font-semibold leading-tight">{l.name}</h3>
                <p className="text-xs uppercase tracking-wider mt-2 mb-4 font-semibold" style={{ color: "var(--zt-navy)" }}>
                  {l.title.length > 40 ? l.title.slice(0, 40) + "…" : l.title}
                </p>
                <p className="text-sm text-slate-600 leading-relaxed">{truncate(l.bio, 160)}</p>
                <button
                  data-testid={`leader-readmore-${i}`}
                  className="mt-4 text-xs font-bold uppercase tracking-wider border-b border-slate-300 hover:border-slate-900 pb-0.5 transition-colors"
                  style={{ color: "var(--zt-navy)" }}
                >
                  Read Full Bio →
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>

      {active && <LeaderModal leader={active} onClose={() => setActive(null)} />}

      <CtaBand
        heading="Speak with our leadership team"
        subtext="For investor inquiries, partnership discussions, or strategic conversations, connect with the ZT Health team directly."
      />
    </div>
  );
}
